import React from "react";
import footerItemsList from "./footerItemsList";
import FooterItem from "./FooterItem";
import uuid from "react-uuid";
import ADDRESS from "../../components/Main/minting";

const Footer = () => {
	return (
		<div className="w-full text-white bg-black flex flex-col md:grid grid-cols-2 place-items-center p-4 py-10 gap-y-6 md:gap-y-4">
			<div className="flex flex-col place-items-center gap-y-4">
				<h1 className="text-4xl gradient-w-bg">Mōmoku</h1>
				<div>
					<FooterItem
						text="Contract Address"
						href={`https://etherscan.io/address/0xd1f49f4882860bb311ff549f4393b9adaa82ab64`}
					/>
				</div>
			</div>
			<div className="flex flex-col place-items-center gap-y-4">
				<h2 className="text-2xl font-semibold gradient-w-bg">Links</h2>
				{footerItemsList.map((footerItem) => {
					const { text, href } = footerItem;
					return <FooterItem key={uuid()} text={text} href={href} />;
				})}
			</div>
		</div>
	);
};

export default Footer;
